var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingCalander(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .667V2h4V.667h1.334V2h2.667c.368 0 .666.299.666.667v10.667a.667.667 0 01-.666.666H2a.667.667 0 01-.667-.666V2.667c0-.368.298-.667.667-.667h2.666V.667h1.334zm7.334 6H2.667v6h10.667v-6zm-3.31.757l.943.943-3.3 3.3L5.31 9.31l.943-.943 1.414 1.414 2.357-2.357zm-5.357-4.09h-2v2h10.667v-2h-2V4h-1.333v-.666H6V4H4.667v-.666z",
    fill: "#E95832"
  })));
}
export default __webpack_public_path__ + "static/media/booking-calander.1f03cd0a.svg";
export { SvgBookingCalander as ReactComponent };